const LandingPageView = () => {
    return (
        <section className="landing-page">
            <div className="landing-wrapper">
                <div className="charging-operator">
                    <h1>Charging <br/>
                        Operator</h1>
                </div>
                <div className="landing-image flex-row-center-center">
                    <img src="img/landing-page-laptop-phone.png" alt="Charging operator app" />
                </div>
            </div>
        </section>
    );
}
 
export default LandingPageView;
